/**
 * @file The select account identities container.
 */

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import { MeForAlbumPurchaseIdentities } from '../../graphql/queries/account';
import SelectAccountIdentities from '../../components/purchase/SelectAccountIdentities';
import { openModal } from '../../actions/modal-actions';
import {
  getPurchasedIdentities,
  getSelectedIdentities,
} from '../../util/account';
import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';

const withUserData = graphql(MeForAlbumPurchaseIdentities, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
    },
  }),
  props: ({ data: { me, loading }, ownProps: { match } }) => ({
    loading,
    identities: get(me, 'linked_identities.records', []),
    purchasedIdentities: getPurchasedIdentities(me, match.params.albumId),
    joinedIdentities: getSelectedIdentities(me, match.params.albumId),
  }),
});

const mapStateToProps = ({ purchaseAlbum }) => ({
  selectedIdentitiesForPurchase: purchaseAlbum.identitiesForPurchase,
  selectedIdentitiesForJoin: purchaseAlbum.identitiesForJoin,
});

const mapDispatchToProps = {
  openModal,
};

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

export default compose(
  withRouter,
  withUserData,
  withAlbumData,
  connect(mapStateToProps, mapDispatchToProps),
)(SelectAccountIdentities);
